import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { OmFormDropdownFieldWrapper } from '@om/component-library-react';
import FundDeclarationTable from './FundDeclarationTable';
import FundDeclarationModal from './FundDeclarationModal';
import {
    getIsNameApiFailure,
    getIsNameApiPending,
    getIsNameApiSuccess,
    getListOfFunds,
    getSelectedFundId,
} from '../../../../redux/selectors/fundDeclarations/fundDeclarations';
import {
    getFundNames,
    getFunds,
    setSelectedFundValue,
} from '../../../../redux/actions/fundDeclarations/fundDeclarations';
import './FundDeclarations.scss';

const FundDeclarations = ({ uid, slot }) => {
    const dispatch = useDispatch();

    const {
        selectedFundId,
        fundList,
        isNameApiPending,
        isNameApiFailure,
        isNameApiSuccess,
    } = useSelector(
        createStructuredSelector({
            selectedFundId: getSelectedFundId,
            fundList: getListOfFunds,
            isNameApiPending: getIsNameApiPending,
            isNameApiFailure: getIsNameApiFailure,
            isNameApiSuccess: getIsNameApiSuccess
        })
    );

    useEffect(() => {
        dispatch(getFunds());
        dispatch(getFundNames());
    }, [dispatch]);

    let funds = fundList;
    let placeHolderText;
    if (isNameApiPending) {
        placeHolderText = 'Loading Funds';
    } else if (isNameApiFailure || funds.length === 0) {
        placeHolderText = 'No funds available, try again';
    } else {
        placeHolderText = 'Select OM Fund';
    }

    return (
        <div className="fund-declaration-container" slot={slot}>
            <div className="fund-selector">
                <OmFormDropdownFieldWrapper
                    onOnSelect={(event) =>
                        dispatch(setSelectedFundValue(event.detail.id))
                    }
                    value={selectedFundId}
                    useNativeMobileDropdown={true}
                    required={true}
                    size="small"
                    formId="fund-declarations"
                    placeholder={placeHolderText}
                    label="Select an Old Mutual Fund"
                    placeholderAsLabel={false}
                    labelAlwaysShow={true}
                    align="left"
                    disabled={!isNameApiSuccess}
                    options={JSON.stringify(
                        funds &&
                            funds.map((fund) => ({
                                value: fund.fundId,
                                label: fund.fundName,
                            }))
                    )}
                />
            </div>

            {selectedFundId && (
                <React.Fragment>
                    <FundDeclarationTable />
                    <FundDeclarationModal />
                </React.Fragment>
            )}
        </div>
    );
};

export default FundDeclarations;
